import SimpleHomeBreadcrumb from '@Components/Shared/SimpleHomeBreadcrumb';

const CaliforniaPrivacyPolicy = (props) => {
    return (
        <div className='info-content-container'>
            <div className='info-content-header'>
                <SimpleHomeBreadcrumb homeRoute={props.BreadCrumbHomeRoute} displayText={props.BreadCrumbText} />
            </div>
            <div className='privacy-policy-container'>
                <span dangerouslySetInnerHTML={{ __html: props.HtmlMarkup }} />
            </div>
        </div>
    );
};

export default CaliforniaPrivacyPolicy;
global.CaliforniaPrivacyPolicy = CaliforniaPrivacyPolicy;